import {Card, Flex, Stack, Text} from '@sanity/ui'
import React from 'react'
import {PreviewLayoutKey, PreviewProps} from 'sanity'

type Props = PreviewProps<PreviewLayoutKey> & {
  shadow?: boolean
}

export const ComponentPreview: React.FC<Props> = ({shadow = true, ...props}) => {
  return (
    <ComponentPreviewWrapper shadow={shadow} {...props}>
      {props.renderDefault(props)}
    </ComponentPreviewWrapper>
  )
}

type ComponentPreviewWrapperProps = PreviewProps<PreviewLayoutKey> & {
  shadow?: boolean
}

const ComponentPreviewWrapper: React.FC<ComponentPreviewWrapperProps> = ({shadow, ...props}) => {
  const Icon = props.schemaType?.icon
  const name = props.schemaType?.title
  return (
    <Card padding={3} shadow={shadow ? 1 : undefined} radius={shadow ? 2 : undefined}>
      <Stack gap={3}>
        <Flex align="center" gap={2}>
          <Text size={1}>{Icon && <Icon />}</Text>
          <Text size={1} weight="semibold">
            {name}
          </Text>
        </Flex>
        {props.children}
      </Stack>
    </Card>
  )
}
